import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Table } from 'antd'

class StudentPointsModal extends Component {

    // 基礎通用參數 //////////////////////////////////////////////
    static propTypes = {
        points: PropTypes.array.isRequired
    }

    state = {
        loading: false,
    }

    UNSAFE_componentWillMount() {
    }

    componentDidMount() {
    }

    // 遠端數據處理 //////////////////////////////////////////////

    // 數據配置設定 ////////////////////////////////////////////// 

    /////////////////////////////////////////////////////////////     
    render() {
        //console.log(this.props.points)
        return (
            <>
                <Table
                    dataSource={this.props.points}
                    columns={[
                        {
                            title: '姓名',
                            dataIndex: 'participantsName',
                            width: 20,
                            responsive: ['md'],
                        },
                        {
                            title: '自學項目',
                            dataIndex: 'activityTitle',
                            width: 40,
                        },
                        {
                            title: '點數',
                            dataIndex: 'getPoints',
                            width: 10,
                        },
                        {
                            title: '歸屬',
                            dataIndex: '',
                            width: 10,
                            responsive: ['md'],
                            render: (item) => {
                                const { getLevel } = item
                                return (
                                    <>
                                        {getLevel === 1 ? '大一' : '大二'}
                                    </>
                                )
                            }
                        },
                    ]}
                    bordered
                    pagination={false}
                    scroll={{ y: 480 }}
                    rowKey='id'
                />
            </>
        )

    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(StudentPointsModal)